import {Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {FilterService} from "@app/services/filter.service";
import {Table, TableColResizeEvent, TableLazyLoadEvent} from "primeng/table";
import {PAGINATION_OPTIONS} from "@app/components/supplies/supplies.component";
import {HttpErrorResponse, HttpParams} from "@angular/common/http";
import {ActionsController} from "@app/ui_controllers/actionsController";
import {MedOptionType} from "@mk/med-ui";
import {LogAction} from "@app/ui_models/model-dto";
import {DatePipe} from "@angular/common";
import {MedNotificationService} from "@mk/med-notification";
import {StatusTranslatorService} from "@app/services/status.translator.service";
import {AccountService} from "@app/services/account.service";

@Component({
  templateUrl: "./actions.component.html",
  styleUrls: ["/actions.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ActionsComponent implements OnInit  {

    constructor(
      private actionsController: ActionsController,
      private notificationService: MedNotificationService,
      public filter: FilterService,
      public statusTranslatorService: StatusTranslatorService,
      public accountService: AccountService
    ) {}

  @ViewChild("dt") dt: Table | undefined;
  tableBody:  LogAction[] = [];
  rows = 0;
  totalRows = 0;
  pageSize = 10;
  selectedPageNumber = 1;
  sortOrder: number | undefined | null = null;
  filterActive = true;
  filterField: string | string[] | null | undefined = "";
  tableState: TableLazyLoadEvent = {};
  loadingCounter = 0;
  tabHeaderActions: { label: string; key: string; date: boolean; filter: boolean; width: string }[] = [
    {label: "Тип дії", key: "actionType", date: false, filter: true, width: "initial"},
    {label: "Дата і час", key: "createdAt", date: false, filter: true, width: "initial"},
    {label: "Ініціатор", key: "initiator", date: false, filter: true, width: "initial"},
    {label: "Об`єкт дії", key: "actionObject", date: false, filter: false, width: "initial"},
    {label: "Деталі", key: "details", date: false, filter: true, width: "initial"},
    {label: "Статус до змін", key: "statusBefore", date: false, filter: true, width: "initial"},
    {label: "Статус після змін", key: "statusAfter", date: false, filter: true, width: "initial"},
    {label: "Адресат", key: "destination", date: false, filter: true, width: "initial"}
  ];
  showedOnPage = 10;
  filtersSubscriber: any = {};
  readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;

    ngOnInit(): void {
      this.filtersSubscriber = this.filter.actionsSubject.subscribe(() => {
        this.getActions(this.selectedPageNumber);
      });
      this.loadColumnOrder();
    }

  isVisibleFilters(): boolean {
    return this.filter.showActionsFilter;
  }

  saveColumnOrder() {
    localStorage.setItem("actionsColumnOrder", JSON.stringify(this.tabHeaderActions));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("actionsColumnOrder");
    if (savedOrder) {
      this.tabHeaderActions = JSON.parse(savedOrder);
    }
  }

  loadData($event: TableLazyLoadEvent, resetState = false) {
    this.tableState = $event;
    this.filterField = $event.sortField;
    if (resetState) {
      if ($event.sortField) {
        this.filterActive = this.sortOrder !== -1;
      } else {
        this.filterActive = false;
      }
    }
    if (this.sortOrder === -1 && resetState) {
      this.sortOrder = null;
      this.dt?.reset();
    } else {
      this.getActions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
      this.sortOrder = $event.sortOrder;
    }
  }

  getActions(
    page: number | undefined,
    order = "desc",
    field = "actionType",
  ): void {
    let params = new HttpParams();
    this.selectedPageNumber = page ? page : 0;
    let sortFieldAndOrder = `${field},${order}`;

    params = params.append("page", this.selectedPageNumber - 1);
    params = params.append("size", this.pageSize);
    params = params.append("sort", sortFieldAndOrder);

    // this.loadingCounter++;
    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);
    this.actionsController.searchActions(this.addFilterParams(params)).subscribe(data => {
      this.tableBody = data.content;
      console.log(this.tableBody)
      this.totalRows = data.totalElements;
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    }, (error: HttpErrorResponse) => {
      this.notificationService.error(error.message)
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });
    // this.actionsController.searchLogActions().subscribe(data => {
    //   this.tableBody = data;
    // })
  }

  addFilterParams(params: HttpParams): HttpParams {
    const subscriber = this.filter.actionsSubject.subscribe(data => {
      let counter = 0;
      if (data.actionTypes.length) {
        params = params.append(`conditions[${counter}].fieldName`, "actionType");
        params = params.append(`conditions[${counter}].values`, data.actionTypes.join(", "));
        params = params.append(`conditions[${counter}].operator`, "IN");
        counter++;
      }

      if (data.createdAt.length) {
        const datepipeExpected: DatePipe = new DatePipe("en-US");
        let formattedDate = datepipeExpected.transform(new Date(data.createdAt[0]), "YYYY-MM-dd HH:mm");
        params = params.append(`conditions[${counter}].fieldName`, "createdAt");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
        counter++;

        formattedDate = datepipeExpected.transform(new Date(data.createdAt[1]), "YYYY-MM-dd HH:mm");
        params = params.append(`conditions[${counter}].fieldName`, "createdAt");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "LESS_THAN_EQUALS");
        counter++;
      }

      if (data.initiator.length) {
        params = params.append(`conditions[${counter}].fieldName`, "initiator");
        params = params.append(`conditions[${counter}].value`, data.initiator[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
    });
    subscriber.unsubscribe();
    return params;
  }

  getFirstShowedRowIndex(): number {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.loadData(this.tableState);
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.loadData(this.tableState);
  }

  downloadExcel() {
    this.actionsController.downloadActionsExcel(this.addFilterParams(new HttpParams()))
      .subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'actions.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
      }, (error: HttpErrorResponse) => {
        if (error.status === 416) {
          this.notificationService.error("Експорт можливий лише за період до 1 року.");
        }
    });
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
      case "DRAFT": color = "grey"; break;
      case "PENDING_APPROVAL": color = "yellow"; break;
      case "AWAITING_DOZ_DISTRIBUTION": color = "yellow"; break;
      default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getEntityName(actionObject: any): string {
      let name = ""
    if (actionObject) {
      if (actionObject.includes("Distribution")) {
        name = "Розподіл"
      }
    }
    return name;
  }

  getHref(actionObject: any): string {
    let href = ""
    if (actionObject) {
      if (actionObject.includes("Distribution")) {
        if (this.accountService.isDOZ()) {
          href = "#/distributions/doz/view/" + actionObject.split(": ")[1]
        } else {
          href = "#/distribution/view/" + actionObject.split(": ")[1]
        }
      }
    }
    return href
  }

  handleColumnResize($event: TableColResizeEvent) {
    this.tabHeaderActions.forEach(element => {
      if (element.label === $event.element.innerText.trim()) {
        element.width = $event.element.clientWidth + "px";
      }
    })
    this.saveColumnOrder();
  }
}
